// extracted by mini-css-extract-plugin
export default {"main":"presente_main__-CTUR","title":"presente_title__NDnpN"};